import microuniversoApi from "app/api/microuniversoApi";
import { sobrescreverInformacoesAction } from "app/redux/orcamentoSlice";
import store from "app/redux/store/store";
import { Endereco } from "app/types/Endereco";
import { WindowMU } from "app/types/WindowMU";

declare var window:WindowMU

export async function SalvarEnderecoOrcamento (enderecos: Endereco[]) {

    const resultado = await microuniversoApi.Orcamento.SalvarEnderecoOrcamento(store.getState().orcamento.IdentificadorOrcamento, enderecos)

    //const orcamentoLegado = window.orcamentoController.model
    if (!("HasErrors" in resultado)) {
        store.dispatch(sobrescreverInformacoesAction({...resultado}))

        // orcamentoLegado.set("Enderecos", resultado.Enderecos)
        // orcamentoLegado.set("DescontoAcumulado", resultado.DescontoAcumulado)
        // orcamentoLegado.set("ItensOrcamento", resultado.ItensOrcamento)
        // orcamentoLegado.set("PercentualDesconto", resultado.PercentualDesconto)
        // orcamentoLegado.set("PercentualDescontoAcumulado", resultado.PercentualDescontoAcumulado)
        // orcamentoLegado.set("PercentualSeguroEntrega", resultado.PercentualSeguroEntrega)
        // orcamentoLegado.set("SubTotal", resultado.SubTotal)
        // orcamentoLegado.set("ValorAcrescimoFinanceiro", resultado.ValorAcrescimoFinanceiro)
        // orcamentoLegado.set("ValorDesconto", resultado.ValorDesconto)
        // orcamentoLegado.set("ValorDespesasInclusas", resultado.ValorDespesasInclusas)
        // orcamentoLegado.set("ValorFrete", resultado.ValorFrete)
        // orcamentoLegado.set("ValorIPI", resultado.ValorIPI)
        // orcamentoLegado.set("ValorSeguroEntrega", resultado.ValorSeguroEntrega)
        // orcamentoLegado.set("ValorSubstituicao", resultado.ValorSubstituicao)
        // orcamentoLegado.set("ValorTotal", resultado.ValorTotal)
        // orcamentoLegado.set("ValorTotalPendente", resultado.ValorTotalPendente)
        // orcamentoLegado.set("ValorTotalSolicitado", resultado.ValorTotalSolicitado)
        // orcamentoLegado.set("ValorDescontoIcms", resultado.ValorDescontoIcms)
        // orcamentoLegado.set("ValorTotalMercadorias", resultado.ValorTotalMercadorias)

        // orcamentoLegado.set("ValorTotalMercadoriasNacionais", resultado.ValorTotalMercadoriasNacionais)
        // orcamentoLegado.set("ValorTotalMercadoriasImportadas", resultado.ValorTotalMercadoriasImportadas)
        // orcamentoLegado.set("PercentualDescontoSobreMercadoriasNacionais", resultado.PercentualDescontoSobreMercadoriasNacionais)
        // orcamentoLegado.set("PercentualDescontoSobreMercadoriasImportadas", resultado.PercentualDescontoSobreMercadoriasImportadas)
        // orcamentoLegado.set("ValorDescontoSobreMercadoriasNacionais", resultado.ValorDescontoSobreMercadoriasNacionais)
        // orcamentoLegado.set("ValorDescontoSobreMercadoriasImportadas", resultado.ValorDescontoSobreMercadoriasImportadas)
        // orcamentoLegado.set("TipoTratamentoDesconto", resultado.TipoTratamentoDesconto)
        // orcamentoLegado.set("ValorTotalSTSobreMercadoriasImportadas", resultado.ValorTotalSTSobreMercadoriasImportadas)
        // orcamentoLegado.set("ValorTotalSTSobreMercadoriasNacionais", resultado.ValorTotalSTSobreMercadoriasNacionais)
        // orcamentoLegado.set("ValorTotalIPISobreMercadoriasImportadas", resultado.ValorTotalIPISobreMercadoriasImportadas)
        // orcamentoLegado.set("ValorTotalIPISobreMercadoriasNacionais", resultado.ValorTotalIPISobreMercadoriasNacionais)
        // orcamentoLegado.set("PerdaCotacao", resultado.PerdaCotacao)
        // orcamentoLegado.set("CodigoMotivoDesconto", resultado.CodigoMotivoDesconto)
        // orcamentoLegado.set("UltimaAtualizacao", resultado.UltimaAtualizacao)
        
    }
    return resultado;
}
